import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["AttensiCard"], { class: "loading-component" }, {
    default: _withCtx(() => [
      _createElementVNode("h3", null, _toDisplayString($props.heading), 1 /* TEXT */),
      _createVNode($setup["MenuIcon"], { type: "ai-trond" }),
      _createElementVNode("p", null, _toDisplayString($props.message), 1 /* TEXT */)
    ]),
    _: 1 /* STABLE */
  }))
}